
import './App.css';

function About() {
  return (

    <div className="container">
      <br />
      <h1>About Details</h1>
      <hr/>
      <h6>Sequelize</h6>
      <p>
        Sequelize is a promise-based Node.js ORM for Postgres, MySQL, MariaDB, SQLite and Microsoft SQL Server. It features solid transaction support, relations, eager and lazy loading, read replication and more.</p>
      <h6>Node JS</h6>
      <ul>
        <li>Node.js is an open source server environment</li>
        <li>Node.js is free</li>
        <li>Node.js runs on various platforms (Windows, Linux, Unix, Mac OS X, etc.)</li>
        <li>Node.js uses JavaScript on the server</li>
      </ul>

    </div>
  );
}

export default About;
